class LinkShape {
  constructor(x, y, width, height, url, target = '_blank') {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.url = url;
    this.target = target;

    this.createElement();
  }

  createElement() {
    const el = document.createElement('a');
    el.href = this.url;
    el.target = this.target;

    // Styling
    el.style.position = 'absolute';
    el.style.left = `${this.x}px`;
    el.style.top = `${this.y}px`;
    el.style.width = `${this.width}px`;
    el.style.height = `${this.height}px`;
    
    // Optioneel: centreer de link op het x,y punt (net als CircleShape)
    el.style.transform = 'translate(-50%, -50%)'; 

    el.style.backgroundColor = 'rgba(255, 0, 0, 0.0)'; // Transparant (zet op 0.4 voor testen)
    el.style.zIndex = '1';
    el.style.display = 'block';

    const appendToContainer = () => {
      let container = null;

      if (typeof doek !== 'undefined' && doek && doek.canvas) {
        container = doek.canvas.parentElement;
      } else {
        container = document.getElementById('doek') || document.querySelector('canvas')?.parentElement;
      }

      if (container) {
        container.style.position = 'relative';
        container.appendChild(el);
      } else {
        setTimeout(appendToContainer, 50);
      }
    };

    appendToContainer();
  }
}

window.LinkShape = LinkShape;
export default LinkShape;